import { Component, OnInit } from '@angular/core';
import { EngineService } from '../_services/engine.service';
import { ActivatedRoute } from '@angular/router';
import { Engine } from '../_models/Engine';

@Component({
    selector: 'app-redirect',
    template: ``
})

export class MobileAppStoreRedirectComponent implements OnInit {

    constructor(
        private engineService: EngineService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            const appStoreName = params['id'];

            this.engineService.getEngineByAppStoreName(appStoreName).subscribe(e => {
                if (!e || !e.appleStoreId || !e.appleStoreName || !e.playStoreId) {
                    window.location.href = 'https://cueaudio.com';
                }

                const userAgent = navigator.userAgent || navigator.vendor;

                if (/android/i.test(userAgent)) {
                    window.location.href = 'https://play.google.com/store/apps/details?id=' + e.playStoreId; // com.cueaudio.cue
                } else if (/iPad|iPhone|iPod/.test(userAgent) && !(<any>window).MSStream) {
                    window.location.href = `https://apps.apple.com/us/app/${e.appleStoreName}/id${e.appleStoreId.replace(/[^0-9\.]+/g, "")}`; // cue-live 1326690131
                } else {
                    window.location.href = 'https://cueaudio.com';
                }
            });
        });

    }
}

